import { Nilable } from "@nahuelmorata/ngx-extras";

export interface IPredictDataDTO {
    quality: number,
    predict_very_high: number,
    predict_high: number,
    predict_medium: number
}

export class PredictDataDTO {
    public quality = 0;
    public predictVeryHigh = 0;
    public predictHigh = 0;
    public predictMedium = 0;

    constructor(json: Nilable<Partial<IPredictDataDTO>> = null) {
        if (json != null) {
            this.cargarDTO(json);
        }


    }
    cargarDTO(json: Partial<IPredictDataDTO>) {
        if (json?.quality != null) {
            this.quality = json.quality;
        }
        if (json?.predict_very_high != null) {
            this.predictVeryHigh = json.predict_very_high;
        }
        if (json?.predict_high != null) {
            this.predictHigh = json.predict_high;
        }
        if (json?.predict_medium != null) {
            this.predictMedium = json.predict_medium;
        }
    }
}